// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"ddf26f1d","453":"c2e2cbfa","855":"86b66931"}[chunkId] + ".chunk.js";
};